import { Res } from 'common/types/responses'
import { Req } from 'common/types/requests'
import { service } from 'common/service'
import { subscriptionService } from './useSubscription'
import { getStore } from 'common/store'
import { uniqBy } from 'lodash'

export const assignCompanyGroupService = service
  .enhanceEndpoints({ addTagTypes: ['AssignCompanyGroup'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      createAssignAllCompanyGroups: builder.mutation<
        Res['assignCompanyGroups'],
        Req['assignAllCompanyGroups']
      >({
        invalidatesTags: [{ id: 'LIST', type: 'AssignCompanyGroup' }],
        query: ({ from, to, ...rest }: Req['assignAllCompanyGroups']) => ({
          body: { ...rest },
          method: 'PUT',
          url: `partners/groups/${from}/companies/move/${to}`,
        }),
        transformResponse: (res) => {
          getStore().dispatch(
            subscriptionService.util.invalidateTags(['Subscription']),
          )
          return res
        },
      }),
      createAssignCompanyGroups: builder.mutation<
        Res['assignCompanyGroups'],
        Req['assignCompanyGroups']
      >({
        invalidatesTags: [{ id: 'LIST', type: 'AssignCompanyGroup' }],
        queryFn: async (query, _1, _2, baseQuery) => {
          const companies = uniqBy(
            query.subscriptions,
            (v) => v.company_id,
          ).filter((v) => v.groups?.[0]?.group_id !== query.to)
          const toRemove = companies.filter((v) => !!v.groups?.[0]?.group_id)
          //Remove any existing company groups
          await Promise.all(
            toRemove.map((v) => {
              return v.groups?.map((group) => {
                return baseQuery({
                  body: {},
                  method: 'DELETE',
                  url: `partners/groups/${group.group_id}/companies/${group.id}`,
                })
              })
            }),
          )
          //Add group to all companies that didnt have them
          const { data, error } = await baseQuery({
            body: { company_ids: companies.map((v) => v.company_id) },
            method: 'POST',
            url: `partners/groups/${query.to}/companies`,
          })
          getStore().dispatch(
            subscriptionService.util.invalidateTags(['Subscription']),
          )

          return { data, error }
        },
      }),
      // END OF ENDPOINTS
    }),
  })

export async function createAssignCompanyGroups(
  store: any,
  data: Req['assignCompanyGroups'],
  options?: Parameters<
    typeof assignCompanyGroupService.endpoints.createAssignCompanyGroups.initiate
  >[1],
) {
  return store.dispatch(
    assignCompanyGroupService.endpoints.createAssignCompanyGroups.initiate(
      data,
      options,
    ),
  )
}
export async function createAssignAllCompanyGroups(
  store: any,
  data: Req['assignAllCompanyGroups'],
  options?: Parameters<
    typeof assignCompanyGroupService.endpoints.createAssignAllCompanyGroups.initiate
  >[1],
) {
  return store.dispatch(
    assignCompanyGroupService.endpoints.createAssignAllCompanyGroups.initiate(
      data,
      options,
    ),
  )
}
// END OF FUNCTION_EXPORTS

export const {
  useCreateAssignAllCompanyGroupsMutation,
  useCreateAssignCompanyGroupsMutation,
  // END OF EXPORTS
} = assignCompanyGroupService

/* Usage examples:
const { data, isLoading } = useGetAssignCompanyGroupsQuery({ id: 2 }, {}) //get hook
const [createAssignCompanyGroups, { isLoading, data, isSuccess }] = useCreateAssignCompanyGroupsMutation() //create hook
assignCompanyGroupService.endpoints.getAssignCompanyGroups.select({id: 2})(store.getState()) //access data from any function
*/
